// Flags for cookies that carry a token, cart id or voucher. Browser code reads them,
// so they cannot be HttpOnly; path and lifetime stay with each writer.
export const SECURE_COOKIE_OPTIONS = {
  secure: process.env.NODE_ENV === "production",
  sameSite: "lax",
};
